.serviceRow {
  align-items: stretch;

  & > * {
    flex: 0 0 100px;
  }

  & > :nth-child(1) {
    flex: 0 0 30px;
  }

  & > :nth-child(2) {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
